module.exports = __webpack_public_path__ + "static/media/stop.f9cfd15e.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/trailways/stop.svg
// module id = 944
// module chunks = 0